import {ClassComponent, Vnode} from 'mithril';
import app from 'flarum/forum/app';

interface ErrorPageAttrs {
    error: string
}

export default class ErrorPage implements ClassComponent<ErrorPageAttrs> {
    view(vnode: Vnode<ErrorPageAttrs, this>) {
        const {error} = vnode.attrs;

        return m('div', [
            m('h3', app.translator.trans('kilowhat-formulaire.forum.error-page.' + error + '-title')),
            m('p', app.translator.trans('kilowhat-formulaire.forum.error-page.' + error + '-description')),
        ]);
    }
}
